import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {AbstractSettingsService} from './abstract-settings.service';
import {Injectable} from '@angular/core';

@Injectable()
export class IndustryService extends AbstractSettingsService {
    constructor(configService: ConfigService, httpClient: HttpClient) {
        super(httpClient, configService);
    }

    async getAll(): Promise<string[]> {
        const settings = await this.getSettings();
        return settings.industry_sector;
    }
}